import Vue from 'vue'
import SetSanction from '../models/set_sanction'
import ApiBase from '@/api/apiBase'

class ApiSetSanctions {

    static all(tournament_id, callback, errorCallBack){
        console.log('tournament id', tournament_id);
        ApiBase.get(`/sanctions/tournament/${tournament_id}`, callback, ApiSetSanctions.parseAll, errorCallBack)
    }

    static update(sets, callback, errorCallback) {
        var data = {
            sets: sets
        }
          console.log("Data",data)
  
          ApiBase.post(`/sanctions`, data, callback, ApiBase.noParse, errorCallback)
      }

    static parseAll(response){
        let result = []
        for(var i in response.data.data){
            result.push(SetSanction.parse(response.data.data[i]))
        }
        return result
    }

}

export default ApiSetSanctions


// WEBPACK FOOTER //
// ./src/api/apiSetSanctions.js